import React, { useState } from "react";
import { getFirestore, doc, setDoc } from "firebase/firestore";

const QuizUploader = () => {
  const [slug, setSlug] = useState("");
  const [jsonInput, setJsonInput] = useState("");
  const [status, setStatus] = useState("");

  const db = getFirestore();

  const validateQuizData = (data) => {
    return (
      typeof data === "object" &&
      data.title &&
      Array.isArray(data.questions) &&
      data.questions.every(
        (q) =>
          q.question &&
          Array.isArray(q.answers) &&
          q.answers.every((a) => a.text && typeof a.correct === "boolean")
      )
    );
  };

  const handleUpload = async () => {
    try {
      const data = JSON.parse(jsonInput);

      if (!slug || !validateQuizData(data)) {
        setStatus("❌ Invalid input: Ensure slug, title, and questions are provided and correctly formatted.");
        return;
      }

      await setDoc(doc(db, "quizzes", slug), data);
      setStatus("✅ Quiz uploaded successfully!");
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to upload quiz: " + err.message);
    }
  };

  const handleReset = () => {
    setSlug("");
    setJsonInput("");
    setStatus("");
  };

  return (
    <div style={styles.container}>
      <h2>📤 Upload a Quiz to Firestore</h2>
      <input
        type="text"
        placeholder="Quiz Slug (e.g. matterrock)"
        value={slug}
        onChange={(e) => setSlug(e.target.value)}
        style={styles.input}
      />
      <textarea
        placeholder={`{
  "title": "--Matter Rock--",
  "standardNumber": "PS.2.1",
  "gameType": "multipleChoice",
  "questions": [
    {
      "question": "What are the three states of matter?",
      "answers": [
        { "text": "Solid, Liquid, Gas", "correct": true },
        { "text": "Rock, Paper, Scissors", "correct": false },
        { "text": "Earth, Wind, Fire", "correct": false },
        { "text": "Hot, Cold, Medium", "correct": false }
      ]
    },
    {
      "question": "Which state of matter has a fixed shape?",
      "answers": [
        { "text": "Solid", "correct": true },
        { "text": "Liquid", "correct": false },
        { "text": "Gas", "correct": false },
        { "text": "Plasma", "correct": false }
      ]
    }
  ]
}`}
        value={jsonInput}
        onChange={(e) => setJsonInput(e.target.value)}
        style={styles.textarea}
      />
      <button onClick={handleUpload} style={styles.button}>
        Upload Quiz
      </button>
      <button onClick={handleReset} style={styles.resetButton}>
        Reset
      </button>
      <p>{status}</p>
    </div>
  );
};

const styles = {
  container: { padding: 20, maxWidth: 600, margin: "0 auto", textAlign: "center" },
  input: { width: "100%", padding: 10, marginBottom: 10 },
  textarea: { width: "100%", height: 300, padding: 10 },
  button: { padding: "10px 20px", background: "#4a90e2", color: "#fff", border: "none", marginRight: 10 },
  resetButton: { padding: "10px 20px", background: "#e94e77", color: "#fff", border: "none" },
};

export default QuizUploader;
